let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hlfmI")).then(() => parcelRequire('cA5q0'));